export const routes = (prefix = `billing`) => [
    {
        path: `/${prefix}/bill-patient/:patientID/:visitNO`,
        name: `${prefix}.bill-patient.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.bill-patient.create`,
                PageDescription: "Accounts: Bill patient",
            },
        },
    },
];
